/**
 * @file        src/dcp-error.js
 * @author      Ryan Rossiter, ryan@kingsds.network
 * @date        Feb 2020
 *
 * A super-simple error class with a constructor that accepts an error 'code'
 * and 'info' in addition to the message. Also has another form which accepts an
 * error object to wrap as is second argument which is helpful for dealing with
 * Error Payloads.
 */
'use strict';

const dcpEnv = require('./dcp-env');

exports.DCPError = class DCPError extends Error {
  /**
   * @param {string} [message] - The error message
   * @param {Array<string | object> | Array<object> | Array} [args] - An array consisting of
   * an error code and info object, or an Error object to wrap.
   */
  constructor(message, ...args) {
    super(message);
    this.name = DCPError.name;
    this.timestamp = new Date();
    switch (typeof args[0]) {
      // Form 1: Error code and info object
      case 'string': {
        const [code = '', info = null] = args;
        if (code !== '') {
          this.code = code;
        }

        if (info !== null) {
          this.info = info;
        }
        if (this.stack)
          this.stack = this.stack.replace(/\n[^\n]*\n/, '\n'); /* remove constructor from stack */
        break;
      }
      // Form 2: Error object to wrap
      case 'object': {
        const [error, displayTopStack = true] = args;
        if (error.code) {
          this.code = error.code;
        }

        if (error.info) {
          this.info = error.info;
        }

        if (error.process) {
          this.process = error.process;
        }

        if (error.timestamp) {
          this.timestamp = error.timestamp;
        }

        if (this.stack && displayTopStack)
          this.stack = `${this.stack.replace(/\n[^\n]*\n/, '\n')}\nRethrow ${error.stack ? error.stack : 'stack is not defined'}`;
        else
          this.stack = `${this.name}: ${message}\nRethrow ${error.stack ? error.stack : 'stack is not defined'}`;
        break;
      }
      default:
        break;
    }

    if (!this.process)
      this.process = dcpEnv.getProcessName();
  }
};
